import classNames from "classnames";
import PropTypes from "prop-types";
import { useState } from "react";
import HideIf from "util/HideIf";
import styles from "./tab-selector.module.scss";

const TabSelector = (props: any) => {
  const { tabs, defaultSelectedTab = 0 } = props;

  const [activeTab, setActiveTab] = useState(defaultSelectedTab);
  return (
    <div className={styles.tab_container}>

      <div className={styles.tabs}>
        {
          tabs.map((tab: any, index: any) => (
            <button
              key={tab.title}
              type="button"
              className={classNames(styles.tab, {
                [styles.active_tab]: activeTab === index,
              })}
              onClick={() => setActiveTab(index)}
            >

              <p className={styles.tab_text}>
                {tab.title}
              </p>
            </button>
          ))
        }
      </div>
      {
        tabs.map((tab: any, index: any) => (
          <HideIf show={activeTab === index} key={tab.content}>
            {tab.content}
          </HideIf>
        ))
      }
    </div>
  );
};

TabSelector.propTypes = {
  tabs: PropTypes.shape({
    title: PropTypes.string,
    content: PropTypes.elementType,
  }).isRequired,
};

export default TabSelector;
